// extracted by mini-css-extract-plugin
export default {"separatorWithText":"SeparatorWithText_separatorWithText__ICyl9","line":"SeparatorWithText_line__xAabk","text":"SeparatorWithText_text__LzJAg"};